module.exports = __webpack_public_path__ + "img/pleisure_bodyimage01-2.62c46742.jpg";